import React, { FunctionComponent, useState, useEffect } from 'react'; 
import { Row, Col, Card } from 'react-bootstrap';
import { faCcVisa, faCcAmex, faCcDinersClub, faCcMastercard } from '@fortawesome/free-brands-svg-icons';
import { parseToCoin } from '../../services/AmountService';


type ProductDetailProps = {
    title: string,
    priceMonthly: number,
    priceYear: number,
    descrip: string,
    annualPayment: boolean,
    letMonths: number
}

const CustomProductDetailCard:FunctionComponent<ProductDetailProps> = (props) => {

  const { title, priceMonthly, priceYear, descrip, annualPayment, letMonths } = props;

  const [ priceProduct, setPriceProduct ] = useState(0);
  const  [onetime, setOnetime] = useState(false);
  const icons = {
    visa: faCcVisa,
    amex: faCcAmex, 
    dinners: faCcDinersClub, 
    master: faCcMastercard
  }

  useEffect(() => {

    /*
    if (priceMonthly==0) {
      setOnetime(true);
      setPriceProduct(priceYear)
    } else {
    if(annualPayment){
      const priceCalc = priceYear * letMonths;
      setPriceProduct(priceCalc);
    }else if(!annualPayment){
      setPriceProduct(priceMonthly);
    }
    }*/
  }, [annualPayment])

  return(
    <Card className="product-detail-card mb-3">
      <Card.Body className="p-3">
        <Card.Title>
          <Row>
            <Col><span className="title-product">{title}</span></Col>
          </Row>
        </Card.Title>
        <div className="border-top my-2"></div>
        <Card.Text>
          <Row>
            <Col md="6">
              <span>
                {descrip}
              </span>
            </Col>
            <Col md="6" className="text-right my-auto">
            {annualPayment ?
              <span><span className="product-price">{parseToCoin(priceYear*10)}</span>/year</span>
              : <span><span className="product-price">{parseToCoin(priceMonthly)}</span>{annualPayment ? '/year' : '/month'}</span>
              }
            </Col>
          </Row>
        </Card.Text>
      </Card.Body>
    </Card>
    );
}

export default CustomProductDetailCard;